module.exports = __webpack_public_path__ + "static/og-image-b3636ccdcaa8a79bb54ecd53e09c351f.png";